import { ReportShapeItem, ShapeType } from '../../reportsTypes';
import * as z from 'zod';
import { ZodObject } from 'zod';
import { geometrySchema } from '@ais-ui/utils';

export function createDynamicShapeZodSchema(
  shapeItems: ReportShapeItem[] | undefined,
  type: ShapeType,
  instantShape?: boolean | undefined
): ZodObject<Record<string, z.ZodTypeAny>> {
  const schemaFields: Record<string, z.ZodTypeAny> = {};

  if (!shapeItems) {
    return z.object(schemaFields);
  }

  if (type === 'multiShape') {
    for (const shapeItem of shapeItems) {
      // The string represents an id of a shape and the geometrySchema an ad hoc created shape
      schemaFields[shapeItem.name] = z.array(
        z.union([z.string(), geometrySchema])
      );
    }
  } else if (type === 'worldShape') {
    for (const shapeItem of shapeItems) {
      schemaFields[shapeItem.name] = z.boolean();
    }
  } else if (type === 'ports') {
    for (const shapeItem of shapeItems) {
      schemaFields[shapeItem.name] = z.array(z.string()).min(1);
    }
  } else if (instantShape) {
    for (const shapeItem of shapeItems) {
      schemaFields[shapeItem.name] = geometrySchema;
    }
  } else {
    for (const shapeItem of shapeItems) {
      schemaFields[shapeItem.name] = z.string();
    }
  }

  return z.object(schemaFields);
}
